import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap'
import PropTypes from 'prop-types'
import {
  AvForm,
  AvField,
} from 'availity-reactstrap-validation'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const AddressInput = (
  {
    isOpen,
    toggle,
    loading,
    onChange,
    onValidSubmit,
    title,
    abode_name_no,
    building_no,
    street,
    city,
    county,
    postcode,
    name,
  }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <AvForm onValidSubmit={() => {
        onValidSubmit({
          abode_name_no,
          building_no,
          street,
          city,
          county,
          postcode,
          name,
        })
      }}>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>
          <AvField
            label="Address No/Name"
            type="text"
            name="abode_name_no"
            id="abode_name_no"
            size="sm"
            value={abode_name_no}
            onChange={evt => {
              onChange({key: 'abode_name_no', value: evt.target.value})
            }}
          />
          <AvField
            label="Building No"
            type="text"
            name="building_no"
            id="building_no"
            size="sm"
            value={building_no}
            onChange={evt => {
              onChange({key: 'building_no', value: evt.target.value})
            }}
          />
          <AvField
            label="Street"
            type="text"
            name="street"
            id="street"
            size="sm"
            value={street}
            onChange={evt => {
              onChange({key: 'street', value: evt.target.value})
            }}
          />
          <AvField
            label="City"
            type="text"
            name="city"
            id="city"
            size="sm"
            value={city}
            onChange={evt => {
              onChange({key: 'city', value: evt.target.value})
            }}
          />
          <AvField
            label="County"
            type="text"
            name="county"
            id="city"
            size="sm"
            value={county}
            onChange={evt => {
              onChange({key: 'county', value: evt.target.value})
            }}
          />
          <AvField
            label="Postcode"
            type="text"
            name="postcode"
            id="postcode"
            size="sm"
            value={postcode}
            onChange={evt => {
              onChange({key: 'postcode', value: evt.target.value})
            }}
          />
          <AvField
            label="Nickname"
            type="text"
            name="name"
            id="name"
            size="sm"
            value={name}
            onChange={evt => {
              onChange({key: 'name', value: evt.target.value})
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button
              size="sm"
              color="success"
              disabled={loading}
          >
              <FontAwesomeIcon
                  color="#fff"
                  icon={loading ? 'spinner' : 'save'}
                  spin={loading}
              />
              {' '}
              {loading ? 'Saving...' : 'Save'}
          </Button>
        </ModalFooter>
      </AvForm>
    </Modal>
  )
}

AddressInput.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  title: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onValidSubmit: PropTypes.func.isRequired,
  abode_name_no: PropTypes.string,
  building_no: PropTypes.string,
  street: PropTypes.string,
  city: PropTypes.string,
  county: PropTypes.string,
  postcode: PropTypes.string,
  name: PropTypes.string,
}

export default AddressInput;